import { TextField } from '@mui/material'
import PhoneNumber from 'awesome-phonenumber'
import intl from 'localization/components'

interface PhoneProps {
  messages: Record<string, string>
  props: {
    value?: string | number
    onChange: (value: string) => void
  }
}

const Phone = ({ messages, props }: PhoneProps) => {
  const { value, onChange } = props
  const phone = new PhoneNumber(value?.toString() ?? '', 'dk').getNumber(
    'international',
  )
  return (
    <TextField
      size="small"
      style={{ width: '100%' }}
      value={phone}
      label={messages[intl.companyInfo('phone')]}
      onChange={(event) => {
        return onChange(event.target.value)
      }}
    />
  )
}

export default Phone
